module.exports = __webpack_public_path__ + "assets/img/girl@2x.9637559e.png";